module.exports = __webpack_public_path__ + "static/media/icon_compare_inactive.dd751e87.svg";